export class HttpClient {
    baseUrl;
    authToken;
    sdkMetadata;
    constructor(config) {
        this.baseUrl = config.baseUrl;
        this.authToken = config.authToken;
        this.sdkMetadata = config.sdkMetadata;
    }
    async send(endpoint, data) {
        const url = new URL(endpoint, this.baseUrl);
        // Add SDK metadata to the request body
        const requestBody = {
            ...data,
            ...(this.sdkMetadata && { sdk: this.sdkMetadata }),
        };
        try {
            const response = await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(this.authToken && { Authorization: `Bearer ${this.authToken}` }),
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                return null;
            }
            let responseData;
            try {
                responseData = await response.json();
            }
            catch {
                responseData = {};
            }
            return responseData;
        }
        catch (error) { }
    }
}
